export enum Form101SearchType {
  ALL,
  MISSING,
  ELECTRONIC,
  MANUAL,
  MANUAL_OR_ELECTRONIC,
  NOT_REQUIRED
}

export const Form101SearchTypeObj = {
  0: 'all',
  1: 'missing',
  2: 'electronic',
  3: 'manual',
  4: 'manualOrElectronic',
  5: 'notRequired',
};

export enum CubeFetchMode {
  WAITING_FOR_UPDATE = 'WAITING_FOR_UPDATE',
  IGNORED = 'IGNORED',
  SENDING_TO_UPDATE = 'SENDING_TO_UPDATE',
  DONE = 'DONE',
}
